import React from 'react'
import { l } from '@manychat/manyui'

import { requestWAUpgrade } from 'apps/whatsApp/utils'
import { UpgradeSource } from 'common/billing'
import cm from 'common/core/components/NotifyBar/StaticNotifications/StaticNotifications.module.css'

const WAUpgradeToProNotification = () => {
  const handleButtonClick = () => {
    requestWAUpgrade({
      source: UpgradeSource.WA_UPGRADE_TO_PRO,
    })
  }

  return (
    <>
      <span>
        {l.translate(
          'Upgrade to Pro to start using WhatsApp channel and get access to important features to grow your business.',
        )}
      </span>
      <a className={cm.more} onClick={handleButtonClick}>
        {l.translate('Upgrade to Pro')}
      </a>
    </>
  )
}

export default WAUpgradeToProNotification
